﻿import * as ko from 'knockout'

import "@/Components/Pages/Login/LoginViewModel"

const element = document.getElementById('login-component');

const dataElement = document.getElementById('login-data');

if (element && dataElement) {

    const config = JSON.parse(dataElement.textContent!);

    ko.applyBindings(config, element);
}